import { apiService } from '../../shared/services/apiService';
import { SendMessageData, LegacySendMessageData } from '../interfaces/SendMessageData';
import { NotGotMessageUser } from '../interfaces/NotGotMessageUser';

type SendMessageResponse = {
  sent: NotGotMessageUser[];
};

export const communicationService = {
  async sendMessage(messageData: SendMessageData) {
    const resp = await apiService.post<SendMessageResponse>(
      '/api/data-filters/communication/message',
      messageData,
    );

    return resp.data;
  },

  async sendMessageViaLegacyApi(data: LegacySendMessageData) {
    const resp = await apiService.post<SendMessageResponse>(
      '/api/coach/message/users',
      data,
    );

    return resp.data;
  },
};
